import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import { RouteConfig } from '../shared/interfaces/routes-config.interface';
import { PaymentsListContainer } from './containers/payments-list/payments-list.container';
/**
 * function UnitTypeModule components
 */
export const PaymentsModule: React.FC = () => {
  return (
    <>
      <Route exact path={APP_ROUTES.PAYMENTS_MODULE.FULL_PATH}>
        <Redirect to={(APP_ROUTES.PAYMENTS_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH} />
      </Route>
      <Route
        path={(APP_ROUTES.PAYMENTS_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH}
        component={PaymentsListContainer}
      />
    </>
  );
};
